var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.168 18C36.168 27.9411 28.1091 36 18.168 36C8.22684 36 0.167969 27.9411 0.167969 18C0.167969 8.05887 8.22684 0 18.168 0C28.1091 0 36.168 8.05887 36.168 18Z",
    fill: "#D4D3D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.168 7.39453C21.1765 7.39453 23.6154 9.72736 23.6154 12.6051C23.6154 15.4828 21.1765 17.8156 18.168 17.8156C15.1595 17.8156 12.7206 15.4828 12.7206 12.6051C12.7206 9.72736 15.1595 7.39453 18.168 7.39453ZM18.1675 20.0589C11.7887 20.0589 6.50783 24.7594 5.59961 30.8855C8.84359 34.0502 13.2781 36 18.168 36C23.0575 36 27.4916 34.0505 30.7355 30.8864C29.8277 24.7598 24.5466 20.0589 18.1675 20.0589Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightPlaceholder);
export default __webpack_public_path__ + "static/media/right_placeholder.5106f4dd40ea6fde627f9faea94d8f0a.svg";
export { ForwardRef as ReactComponent };